export default __webpack_public_path__ + "static/media/lock-red-icon.1f1e6a3f.svg";